/** The product version the pipeline baked in (steps/frontend-env.yml); nothing in a local run. */
export default function AppVersion() {
  const version = import.meta.env.VITE_APP_VERSION;

  if (!version) return null;

  return <footer className="app-version">Version {version}</footer>;
}
